import { GetDealAccountsByIdsRequestDto } from "./deals.requestsDto";

const controller = "deals";

export default {
  controller,
  document: controller + "/document",
  accountDocument: controller + "/accounts/document",
  accountPayments: controller + "/accounts/payments",
  accountClosingDocuments: controller + "/accounts/closing-documents",
  accountClosingDocumentsUpload: controller + "/accounts/closing-documents/upload",
  routes: (id: number) => controller + `/${id}/routes`,
  waitForUpdate: (id: number) => controller + `/${id}/wait-for-update`,
  waitForRoutesUpdate: (id: number) => controller + `/${id}/routes/wait-for-update`,
  byId: (id: number) => controller + "/" + id,
  pendingFill: controller + "/pending-fill",
  filterLite: controller + "/filter-lite",
  accountClosingDocumentsFilter: controller + "/accounts/closing-documents/filter",
  accountClosingDocumentsExport: controller + "/accounts/closing-documents/export",
  accountsByIds: (dto: GetDealAccountsByIdsRequestDto) => controller + "/accounts/" + dto.ids.join(","),
  bonuses: controller + "/bonuses",
  bonusesFilter: controller + "/bonuses/filter",
  bonus: (id: number) => controller + "/bonuses/" + id,
  lite: (id: number) => controller + "/" + id + "/lite",
  cargo: (dealId: number) => controller + "/" + dealId + "/cargo",
  importCargoPackingList: (dealId: number) => controller + "/" + dealId + "/cargo/packing-lists/import",
  segmentsReplaceAll: (dealId: number) => controller + "/" + dealId + "/segments/replace-all",
  vehiclesReplaceAll: (dealId: number) => controller + "/" + dealId + "/vehicles/replace-all",
};
